// @ts-nocheck
import styles from "./SuccessPayment.module.scss";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import useUrlData from "store/DataStore";
import { useParams, useNavigate } from "react-router-dom";
import { getOrderData } from "services/api";

const POLLING_INTERVAL = 5000;

const SuccessPayment = () => {
  const { t } = useTranslation();
  const { orderId } = useParams<{ orderId: string }>();
  const navigate = useNavigate();
  const { data: allData, mapServerData, setMockData } = useUrlData();
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    if (orderId === 'mock') {
      setMockData({
        payment_id: "77880g46-f650-6778-c2hh-de9935f5de6g",
        amount: 10000,
        currency: "ARS",
        status_name: "completed",
      });
      setVerified(true);
    }
  }, [orderId, setMockData]);

  useEffect(() => {
    if (!orderId || orderId === 'mock') return;
    const poll = async () => {
      try {
        const apiData = await getOrderData(orderId);
        mapServerData(apiData);
        const s = apiData.state?.toLowerCase();
        if (s === 'expired') { navigate(`/canceled/${orderId}?type=expired`, { replace: true }); return; }
        if (s === 'cancelled' || s === 'canceled') { navigate(`/canceled/${orderId}?type=canceled`, { replace: true }); return; }
        if (s === 'completed' || s === 'finished' || s === 'success') setVerified(true);
      } catch (e) { console.error(e); }
    };
    poll();
    const id = setInterval(poll, POLLING_INTERVAL);
    return () => clearInterval(id);
  }, [orderId, mapServerData, navigate]);

  const formatAmount = (amount: number) => amount?.toLocaleString('es-AR') || '0';

  if (!verified) {
    return (
      <div className={styles.page}>
        <header className={styles.header}>
          <span className={styles.logo}>PagoPay</span>
        </header>
        <div className={styles.content}>
          <div className={styles.spinner} />
          <div className={styles.text}>Verificando...</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <span className={styles.logo}>PagoPay</span>
        <span className={styles.badge}>Completado</span>
      </header>

      <div className={styles.content}>
        <div className={styles.icon}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <div className={styles.title}>Pago confirmado</div>
        <div className={styles.subtitle}>La transacción se completó exitosamente</div>

        <div className={styles.details}>
          <div className={styles.row}>
            <span className={styles.label}>Monto</span>
            <span className={styles.value}>$ {formatAmount(allData.amount)}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>ID</span>
            <span className={styles.value}>{allData.payment_id?.slice(0, 12) || orderId?.slice(0, 12)}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Estado</span>
            <span className={styles.statusOk}>Exitoso</span>
          </div>
        </div>
      </div>

      <footer className={styles.footer}>
        <span>Puede cerrar esta página</span>
      </footer>
    </div>
  );
};

export default SuccessPayment;
